// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "../../../revvComponents";

// Declarations
const SEARCH_LIMIT_LENGHT = 3;

class CatalogSearchBar extends Component {
  _onSubmit = event => {
    event.preventDefault();
    if (!this.props.searchText) {
      return;
    }
    this.props.submitSearch(this.props.searchText);
  };

  _onChange = event => {
    this.props.handleSearchText(event);
    if (event.target.value.length === 0) {
      this.props.handleSearch(event.target.value);
    } else if (event.target.value.length < SEARCH_LIMIT_LENGHT) {
      return;
    }
    this.props.handleSearch(event.target.value);
  };

  _clearSearch = () => {
    this.props.clearSearchText();
  };

  render() {
    return (
      <form onSubmit={this._onSubmit}>
        <div className="catalogsearchbar-wrapper">
          <span className="catalogsearchbar-icon">
            <FontAwesomeIcon icon={["far", "search"]} />
          </span>
          {this.props.searchText && (
            <span
              className="catalogsearchbar-clear-icon"
              onClick={this._clearSearch}
              onKeyPress={this._clearSearch}
              role="button"
              tabIndex="0">
              <FontAwesomeIcon icon={["far", "times-circle"]} />
            </span>
          )}
          <Input
            className="catalogsearchbar-input"
            data-test="product-catalog-search-input"
            value={this.props.searchText}
            placeholder="Search for SKU, Product Name or Description..."
            onChange={this._onChange}
          />
        </div>
      </form>
    );
  }
}

export default CatalogSearchBar;
